// extracted by mini-css-extract-plugin
module.exports = {"photo":"FeedPhotosItem_photo__3eoiH","visualizacao":"FeedPhotosItem_visualizacao__3MOux"};